import type { Demand } from 'types/buyer'
import type { Offer } from 'types/seller'

import { Sun2Icon, SunIcon, WaterIcon, Wind2Icon, WindIcon } from 'icons'
import styled from 'styled-components'
import { BasicStatus } from 'types'

export const ENERGY_TYPE = {
  SOLAR: 'Słońce PPA',
  HYDRO: 'Woda PPA',
  WIND: 'Wiatr PPA'
}

export const STATUS = {
  ACTIVE: 'Aktywny',
  INACTIVE: 'Nieaktywny',
  RESERVED: 'Zarezerwowany',
  BLOCKED: 'Zablokowany',
  ACCEPTED: 'Zaakceptowany',
  FINALIZED: 'Sfinalizowany',
  DELETED: 'Usunięty',
  CLOSED: 'Zamknięty',
  REMOVED: 'Zakończona'
}

export const PRICING_TYPE = {
  GENERAL: 'Ogólna',
  INDIVIDUAL: 'Indywidualna'
}

export const basicStatuses: BasicStatus[] = ['ACTIVE', 'INACTIVE', 'DELETED']

export const demandStatuses: Demand['status'][] = [
  'INACTIVE',
  'ACTIVE',
  'ACCEPTED',
  'CLOSED',
  'DELETED'
]

export const offerStatuses: Offer['status'][] = [
  'INACTIVE',
  'ACTIVE',
  'RESERVED',
  'ACCEPTED',
  'CLOSED',
  'DELETED'
]

export const tomorrow = new Date(new Date().setDate(new Date().getDate() + 1))
  .toISOString()
  .split('T')[0]

export const fiveYearsFromNow = new Date(new Date().setFullYear(new Date().getFullYear() + 5))
  .toISOString()
  .split('T')[0]

const Energy = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const energyType = {
  SOLAR: (
    <Energy>
      <SunIcon /> {ENERGY_TYPE.SOLAR}
    </Energy>
  ),
  SOLAR_2: (
    <Energy>
      <Sun2Icon /> {ENERGY_TYPE.SOLAR}
    </Energy>
  ),
  WIND: (
    <Energy>
      <WindIcon /> {ENERGY_TYPE.WIND}
    </Energy>
  ),
  WIND_2: (
    <Energy>
      <Wind2Icon /> {ENERGY_TYPE.WIND}
    </Energy>
  ),
  HYDRO: (
    <Energy>
      <WaterIcon /> {ENERGY_TYPE.HYDRO}
    </Energy>
  )
}

export const landingPage = 'https://ozeos.pl'

export const URL_PARAM = {
  electricEnergyMeterNumber: 'electricEnergyMeterNumber',
  buildingPermitNumber: 'buildingPermitNumber'
}
